module.exports = __webpack_public_path__ + "img/img28.11063d67.jpg";